function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "52px",
    height: "18px",
    viewBox: "0 0 51 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(92.941176%,20.392157%,16.862745%)",
      fillOpacity: 1
    },
    d: "M 17.703125 9.007812 C 17.703125 13.917969 13.769531 17.902344 8.917969 17.902344 C 4.066406 17.902344 0.136719 13.917969 0.136719 9.007812 C 0.136719 4.09375 4.066406 0.109375 8.917969 0.109375 C 13.769531 0.109375 17.703125 4.09375 17.703125 9.007812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 8.917969 12.816406 C 6.953125 8.308594 5.511719 4.09375 5.511719 4.09375 L 2.5 4.09375 C 2.5 4.09375 4.335938 9.5 7.738281 16.265625 L 10.097656 16.265625 C 13.503906 9.5 15.335938 4.09375 15.335938 4.09375 L 12.324219 4.09375 C 12.324219 4.09375 10.882812 8.308594 8.917969 12.816406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(1.176471%,26.27451%,37.254902%)",
      fillOpacity: 1
    },
    d: "M 46.742188 8.542969 C 45.039062 8.542969 44.910156 10.398438 44.910156 10.398438 L 48.578125 10.398438 C 48.578125 10.398438 48.445312 8.542969 46.742188 8.542969 M 50.800781 12.257812 L 44.910156 12.257812 C 44.910156 12.257812 45.039062 14.246094 47.660156 14.246094 C 48.96875 14.246094 50.277344 13.847656 50.277344 13.847656 L 50.539062 15.96875 C 50.539062 15.96875 49.230469 16.5 47.398438 16.5 C 44.777344 16.5 42.421875 15.171875 42.421875 11.460938 C 42.421875 8.542969 44.253906 6.6875 46.875 6.6875 C 50.800781 6.6875 51.0625 10.664062 50.800781 12.257812 M 30.765625 9.121094 L 31.171875 6.933594 C 31.171875 6.933594 28.039062 5.96875 25.496094 7.753906 L 25.496094 16.511719 L 28.199219 16.511719 L 28.199219 9.394531 C 29.277344 8.574219 30.765625 9.121094 30.765625 9.121094 M 19.5 8.542969 C 17.796875 8.542969 17.667969 10.398438 17.667969 10.398438 L 21.335938 10.398438 C 21.335938 10.398438 21.203125 8.542969 19.5 8.542969 M 23.558594 12.257812 L 17.667969 12.257812 C 17.667969 12.257812 17.796875 14.246094 20.417969 14.246094 C 21.726562 14.246094 23.035156 13.847656 23.035156 13.847656 L 23.296875 15.96875 C 23.296875 15.96875 21.988281 16.5 20.15625 16.5 C 17.535156 16.5 15.179688 15.171875 15.179688 11.460938 C 15.179688 8.542969 17.011719 6.6875 19.632812 6.6875 C 23.558594 6.6875 23.820312 10.664062 23.558594 12.257812 M 37.359375 13.164062 C 35.988281 9.828125 35.304688 6.6875 35.304688 6.6875 L 32.558594 6.6875 C 32.558594 6.6875 33.929688 12.054688 36.265625 16.5 L 38.457031 16.5 C 40.792969 12.054688 42.164062 6.6875 42.164062 6.6875 L 39.417969 6.6875 C 39.417969 6.6875 38.734375 9.828125 37.359375 13.164062 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerve);
export default __webpack_public_path__ + "static/media/verve.bf303541cf30cf08eed998f237cc1b12.svg";
export { ForwardRef as ReactComponent };